import {Button} from "@/components/ui/button"
import {Card} from "@/components/ui/card"
import {IconPointFilled, IconSunLow, IconChevronRight, IconAutomaticGearbox, IconClock, IconPlayerPlay} from '@tabler/icons-react';
import TimeAgo from "@/hooks/timesAge";

import { useState } from "react";
import { 
  Dialog, 
  DialogTrigger, 
  DialogContent, 
  DialogHeader, 
  DialogTitle, 
  DialogDescription 
} from "@/components/ui/dialog";

export default function StepsMessage({message}) {

    const [test, setMessage] = useState({ text: "How was your experience?" });
    
    const [isOpen, setIsOpen] = useState(false); // State to control dialog visibility

  // Function to open the dialog
  const openDialog = () => setIsOpen(!isOpen);

  // Function to close the dialog
  const closeDialog = () => {
    setIsOpen(false);
    console.log(isOpen)
  }

	return (
		<>
			<div className="flex flex-col w-full m-4 hover:cursor-pointer hover:bg-gray-100 p-2 rounded-md" onClick={openDialog}>
				<div className="flex flex-row justify-between ">
					<span className="text-md flex flex-row">
						<span className="font-bold me-2">1 Steps
						</span>
                        performed in the background
						<IconChevronRight size={16}
							className="ml-2 mt-1"/>
					</span>
					<span className="text-muted-foreground text-xs">
						{
						TimeAgo(message.timestamp)
					}
                    </span>
				</div>
            <Dialog open={isOpen} onOpenChange={setIsOpen} >
            <DialogContent className="w-3/4 max-w-full p-0 h-96">
                <Card className="w-full border-none ">
                    <div className="flex flex-row border-b-2 ">
                    <div className="w-1/4 border-e  border-gray-400 p-4">
                        <p className="text-lg font-medium">Agent</p>
                        <p className="text-sm">No description...</p>
                        <p className="flex flex-row p-1 "> <IconAutomaticGearbox size={16} className="mt-1 me-1 "/> Triggered by</p>
                        <p className="mb-4 text-sm">Nursid Ansari</p>
                        <p className="flex flex-row p-1 "> <IconSunLow  size={14} className="my-1.5 me-1"/> Status</p>
 
                        <p className="pb-4">
                            <span  className="flex flex-row border rounded-lg px-1 py-1 text-xs w-20"> 
                              <IconPointFilled size={16} color="blue"/>  Finished</span>   
                        </p>    
                        <p  className="flex flex-row text-sm"> <IconClock size={16} className="my-1 me-1" /> Ran at</p>
                        <p className="text-xs">Oct 23 2024 @ 11:03 AM</p>
                    </div>

                    <div className="w-3/4 flex flex-row">
                        <div className="w-1/2 p-4">
                        <p className="text-lg font-medium mb-2">Input</p>
                        <div className="border rounded-md p-3  rounded-b-none">
                            <p className="text-xs">Message</p>
                            <p className="text-md">remind to wake up</p>
                        </div>
                        <div className="border rounded-md p-3  rounded-t-none">
                            <p className="text-xs">Minutes Until Schedule</p>
                            <p className="text-md">300</p>
                        </div>

                        </div>
                        <div className="w-1/2 p-4">
                         <p className="text-lg font-medium mb-2">Output</p>
                         <div className="border rounded-md p-3  rounded-b-none">
                            <p className="text-xs">Message</p>
                            <p className="text-md">
                                {"{\"trigger_id\":\"agent_-06380bc3-9c40-4498-b1d3-72c995c03de5-todo_group-scheduled_trigger_--_item-c5c94c80-c739-44e6-81f7-fc856f51efad-todo_group-_scheduled_trigger\"}"}
                                </p>
                        </div>
                        <div className="border rounded-md p-3  rounded-t-none">
                            <p className="text-xs">Status</p>
                            <p className="text-md">200</p>
                        </div>
                        
                        </div>
                    </div>
                    </div>
                    
                {/* <span className="flex flex-col items-left justify-center h-full text-lg text-justify text-muted-foreground">
                    {message.text}
                </span> */}
                
           <div className="flex justify-end mt-1 p-4">
           <Button size="xs" variant="outline" className="border-none  hover:bg-gray-200 text-muted-foreground text-sm me-2">
            <IconPlayerPlay size={16} className="me-1 mt-1" />
              Re-run after this step
              </Button>
               <Button size="xs" onClick={closeDialog}>  Cancel</Button>
            </div>
                </Card>
            </DialogContent>
            </Dialog>
            </div>
		</>
	)

}
